import React, { useMemo, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux'
import AppBar from '@mui/material/AppBar';
import Box from '@mui/material/Box';
import Toolbar from '@mui/material/Toolbar';
import IconButton from '@mui/material/IconButton';
import Typography from '@mui/material/Typography';
import Menu from '@mui/material/Menu';
import MenuIcon from '@mui/icons-material/Menu';
import Container from '@mui/material/Container';
import Avatar from '@mui/material/Avatar';
import Button from '@mui/material/Button';
import Tooltip from '@mui/material/Tooltip';
import MenuItem from '@mui/material/MenuItem';
import AdbIcon from '@mui/icons-material/Adb';
import Link from '@mui/material/Link';
import ThemeToggleButton from './theme/ThemeToggleButtons.js';
import { useNavigate, Link as RouterLink } from "react-router-dom";

import {
  logout,
} from "../actions/userActions.js"

import {
  getUserDetails,
} from "../actions/userActions"

import {USER_DETAILS_SUCCESS} from "../constants/userConstants.js"

const NavBar = () => {
  const dispatch = useDispatch()
  const userDetails = useSelector((state) => state.userDetails)
  const userLogin = useSelector((state) => state.userLogin)
  const [anchorElNav, setAnchorElNav] = React.useState(null);
  const [anchorElUser, setAnchorElUser] = React.useState(null);
  useEffect(()=>{
    const userDetailsTmp = localStorage.getItem('todoUserDetails')
    if (userDetailsTmp){

      dispatch({type: USER_DETAILS_SUCCESS,
        payload: JSON.parse(userDetailsTmp)
      })
    }
    else{
      if (userLogin && userLogin.todoUserInfo && Object.keys(userLogin.todoUserInfo).length>0 && userLogin.success)
      dispatch(getUserDetails())
    }
    
  }, [dispatch, userLogin])

  const handleOpenNavMenu = (event) => {
    setAnchorElNav(event.currentTarget);
  };
  const handleOpenUserMenu = (event) => {
    setAnchorElUser(event.currentTarget);

  };

  const handleCloseNavMenu = () => {
    setAnchorElNav(null);
  };

  const handleCloseUserMenu = () => {
    setAnchorElUser(null);
  };
  const settings = useMemo(() => {
    if (userDetails&& userDetails.user && userDetails.user.username) {
      return {
        'Profile': "/profile",
        'Logout': "/login",
      }
    } else {
      return {
        'Sign In': "/login",
        'Sign Up': "/register",


      }

    }
  }, [userDetails]);

  const pages = useMemo(() => {
  
    if (userDetails  && userDetails.user&& userDetails.user.role && userDetails.user.role === "admin") {
      return {
        'Todos': "/todos",
        'Projects': "/projects",
        'Admin Panel': "/admin",

      };
    } else {
      return {
        'Todos': "/todos",
        'Projects': "/projects",

      }

    }
  }, [userDetails]);



  function stringToColor(string) {
    let hash = 0;
    let i;


    for (i = 0; i < string.length; i += 1) {
      hash = string.charCodeAt(i) + ((hash << 5) - hash);
    }

    let color = '#';

    for (i = 0; i < 3; i += 1) {
      const value = (hash >> (i * 8)) & 0xff;
      color += `00${value.toString(16)}`.slice(-2);
    }


    return color;
  }
  function stringAvatar(name) {
    if (name) {
      return {

        sx: {
          bgcolor: stringToColor(name),
        },
        children: `${name.length > 0 ? name[0] : "a"}`,
      }
    }
    else {
      return {
        src: "/static/images/avatar/2.jpg"
      };
    }
  }

  return (
    <AppBar position="static" data-testid="title">
      <Container maxWidth="xl">
        <Toolbar disableGutters>
          <AdbIcon sx={{ display: { xs: 'none', md: 'flex' }, mr: 1 }} />
          <Typography
            variant="h6"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'none', md: 'flex' },
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            LOGO
          </Typography>
          <ThemeToggleButton />

          <Box sx={{ flexGrow: 1, display: { xs: 'flex', md: 'none' } }}>
            <IconButton
              size="large"
              aria-label="account of current user"
              aria-controls="menu-appbar"
              aria-haspopup="true"
              onClick={handleOpenNavMenu}
              color="inherit"
            >
              <MenuIcon />
            </IconButton>
            <Menu
              id="menu-appbar"
              anchorEl={anchorElNav}
              anchorOrigin={{
                vertical: 'bottom',
                horizontal: 'left',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'left',
              }}
              open={Boolean(anchorElNav)}
              onClose={handleCloseNavMenu}
              sx={{ display: { xs: 'block', md: 'none' } }}
            >
              {Object.keys(pages).map((page) => (
                <MenuItem key={page} onClick={handleCloseNavMenu}>
                  <Link
                    href={pages[page]}>
                    <Typography sx={{ textAlign: 'center' }}>{page}</Typography>
                  </Link>
                </MenuItem>
              ))}
            </Menu>
          </Box>
          <AdbIcon sx={{ display: { xs: 'flex', md: 'none' }, mr: 1 }} />
          <Typography
            variant="h5"
            noWrap
            component="a"
            href="/"
            sx={{
              mr: 2,
              display: { xs: 'flex', md: 'none' },
              flexGrow: 1,
              fontFamily: 'monospace',
              fontWeight: 700,
              letterSpacing: '.3rem',
              color: 'inherit',
              textDecoration: 'none',
            }}
          >
            LOGO
          </Typography>
          <Box sx={{ flexGrow: 1, display: { xs: 'none', md: 'flex' } }}>
            {Object.keys(pages).map((page) => (
              <Link
                key={page}
                href={pages[page]}>
                <Button

                  onClick={handleCloseNavMenu}
                  sx={{ my: 2, color: 'white', display: 'block' }}
                >
                  {page}
                </Button>
              </Link>
            ))}
          </Box>
          <Box sx={{ flexGrow: 0 }}>
            <Tooltip title="Open settings">
              <IconButton onClick={handleOpenUserMenu} sx={{ p: 0 }}>
                <Avatar alt={userDetails && userDetails.user && userDetails.user.username ? userDetails.user.username : ""}

                  {...stringAvatar(userDetails && userDetails.user && userDetails.user.username ? userDetails.user.username : null)}

                />
              </IconButton>
            </Tooltip>
            <Menu
              sx={{ mt: '45px' }}
              id="menu-appbar"
              anchorEl={anchorElUser}
              anchorOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              keepMounted
              transformOrigin={{
                vertical: 'top',
                horizontal: 'right',
              }}
              open={Boolean(anchorElUser)}
              onClose={handleCloseUserMenu}
            >
              {Object.keys(settings).map((setting) => (

                <MenuItem key={setting}
                  onClick={() => {
                    if (setting === "Logout") {
                      handleCloseUserMenu();
                      // navigate("/login");
                      dispatch(logout());

                    } else {
                      handleCloseUserMenu();
                    }


                    ;
                  }}
                >

                  <Link
                    href={settings[setting]}>
                    <Typography sx={{ textAlign: 'center' }}>{setting}</Typography>
                  </Link>

                </MenuItem>

              ))}
            </Menu>
          </Box>

        </Toolbar>
      </Container>
    </AppBar>
  );
}
export default NavBar;